import { Component, inject } from '@angular/core';
import {
  FormBuilder,
  FormControl,
  FormGroupDirective,
  NgForm,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { ErrorStateMatcher } from '@angular/material/core';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { CardComponent } from '@vectronic/ui';

export class ConfigurationNameErrorStateMatcher implements ErrorStateMatcher {
  isErrorState(control: FormControl | null, form: FormGroupDirective | NgForm | null): boolean {
    const isSubmitted = form && form.submitted;
    return Boolean(control && control.invalid && (control.dirty || control.touched || isSubmitted));
  }
}

@Component({
  selector: 'vectronic-formly-add-frequency-modal',
  imports: [
    CardComponent,
    ReactiveFormsModule,
    MatInputModule,
    MatFormFieldModule,
    MatButtonModule,
    MatIconModule,
    MatDialogModule,
  ],
  templateUrl: './add-frequency-modal.component.html',
  styles: `
    form {
      margin-top: 1rem;
    }
    mat-form-field {
      display: block;
    }

    .add-frequency {
      &__field {
        margin-top: 6px;
        width: 100%;
      }
      &__action-button {
        display: flex;
        flex-direction: row;
        justify-content: space-around;
      }
    }

    span[matSuffix] {
      margin: 0 0.5rem;
    }
  `,
})
export class AddFrequencyModalComponent {
  data: { devicesAmount: number } = inject(MAT_DIALOG_DATA);
  result: string[];
  dialogRef = inject(MatDialogRef<AddFrequencyModalComponent>);
  private formBuilder = inject(FormBuilder);

  formGroup = this.formBuilder.group({
    startFrequency: [
      135,
      [
        Validators.required,
        Validators.min(135),
        Validators.max(234),
        Validators.pattern(/^\d{3}(\.\d{1,3})?$/),
      ],
    ],
    step: [
      0.01,
      [
        Validators.required,
        Validators.min(0.01),
        Validators.max(0.99),
        Validators.pattern(/^0\.(\d{1,2})$/),
      ],
    ],
    devicesAmount: [
      this.data.devicesAmount,
      [
        Validators.required,
        Validators.min(1),
        Validators.max(this.data.devicesAmount),
        Validators.pattern('^[0-9]*$'),
      ],
    ],
  });
  matcher = new ConfigurationNameErrorStateMatcher();

  onClickSendFrequency() {
    const listOfFrequencies: string[] = [];
    for (let i = 0; i < this.formGroup.value.devicesAmount; i++) {
      const frequency = this.formGroup.value.startFrequency + this.formGroup.value.step * i;
      listOfFrequencies.push(`${frequency.toFixed(3)}`);
    }
    this.dialogRef.close(listOfFrequencies);
  }
}
